<template>
  <div class="Flex_Table tblEntryForm">
    <div class="Flex_Row">
      <div class="Flex_Cell">
        <fieldset>
          <legend>
            <div class="Flex_Table tblEntryForm">
              <div class="Flex_Row">
                <div valign="middle" class="Flex_Cell_Left">
                  <h3>
                    <span style="font-size: 13pt">Short Course Feedback</span>
                  </h3>
                </div>
                <div valign="top" class="Flex_Cell_Left">
                  <input
                    type="button"
                    id="btnInstruction "
                    name="btnInstruction"
                    btnName="btnInstruction"
                    value="Instructions"
                    title="Click to View Instrution"
                    v-on:click="OpenModelInstruction()"
                    style="padding: 5px 15px 5px 15px"
                  />
                </div>
              </div>
            </div>
          </legend>
          <div
            class="Flex_Table tblEntryForm"
            style="
              border: 1px solid #0f31a4;
              border-bottom: 4px solid #0f31a4;
              border-radius: 13px;
              font-size: larger;
              font-family: system-ui;
            "
          >
            <div class="Flex_Row">
              <div
                class="Flex_Cell"
                v-for="(c, index) in lst_FeedbackType"
                :key="c.fbkTypeID"
              >
                <input
                  type="radio"
                  :id="c.fbkTypeID + 'Feedback' + index"
                  :value="c.fbkTypeID"
                  v-model="fBKTypeID"
                  v-on:change="getAnswer(index, c.isFbkGiven)"
                />
                <label
                  :for="c.fbkTypeID + 'Feedback' + index"
                  style="cursor: pointer"
                >
                  {{ index + 1 }} : {{ c.fbkTypeName }}
                </label>
              </div>
            </div>
          </div>
          <div class="Flex_Table" v-if="fBKTypeID != 12" style="width: 100%">
            <div
              class="Flex_Row"
              style="margin-bottom: 8px"
              v-for="(c, index) in lst_Question"
              :key="c.questionID"
            >
              <div class="Flex_Cell" v-if="c.isVisible == 1">
                <span style="font-weight: 700; font-size: 12pt">
                  ({{ index + 1 }}). {{ c.question }} </span
                ><br /><br />
                <span
                  class="ansClass"
                  :classValue="a.answerID"
                  v-for="a in c.answerLst"
                  :key="a.answerID"
                >
                  <input
                    :disabled="isSubmiitted == 1"
                    v-if="c.qTypeID == 1"
                    type="radio"
                    :id="'answer' + c.questionID + a.answerID"
                    :value="a.answerID"
                    v-model="c.answeresEntered"
                    v-on:change="showHideQuestion(c)"
                  />
                  <label
                    :disabled="isSubmiitted == 1"
                    v-if="c.qTypeID == 1"
                    :for="'answer' + c.questionID + a.answerID"
                    style="cursor: pointer"
                  >
                    {{ a.answer }}
                  </label>
                </span>
                <textarea
                  :disabled="isSubmiitted == 1"
                  v-if="c.qTypeID == 3"
                  type="textarea"
                  style="height: 50px; width: 75%; font-size: 12pt"
                  v-model.trim="c.answeresEntered"
                ></textarea>
                <br />
              </div>
            </div>
          </div>
          <div
            class="Flex_Table ekkGrid tblEntryForm"
            v-if="fBKTypeID == 12 && lst_Question.length > 0"
            style="margin-top: 5px"
          >
            <div class="Flex_Row GridHeader">
              <!-- <div class="Flex_Cell" style="width: 5%">Select</div>-->
              <div class="Flex_Cell" style="width: 20%">Speaker/ Faculty</div>
              <div class="Flex_Cell" style="width: 30%">Topic/ Subject</div>
              <div class="Flex_Cell" style="width: 20%">Rating</div>
              <div class="Flex_Cell" style="width: 30%">Remark</div>
            </div>
            <div
              class="Flex_Row GridContent"
              v-for="c in lst_Question"
              :key="c.shortSubjectID"
            >
              <!-- <div class="Flex_Cell" style="width: 5%">
                <input type="checkbox" v-model="c.isSave" />
              </div>-->
              <div class="Flex_Cell" style="width: 20%">
                {{ c.faculty }}
              </div>
              <div class="Flex_Cell" style="width: 30%">
                {{ c.shortSubjectName }}
              </div>
              <div class="Flex_Cell" style="width: 20%">
                <!-- <input
                  type="number"
                  style="width: 90%; text-align: right"
                  v-model="c.rating"
                  max="5"
                  min="0"
                  v-on:keyup="checkValue(c.rating)"
                />-->
                <select
                  :disabled="isSubmiitted == 1"
                  id="ddlActionType"
                  v-on:change="
                    c.remark = c.rating > 2 || c.rating == -1 ? '' : 'Select'
                  "
                  v-model="c.rating"
                >
                  <option value="-1">Select</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <!-- <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option> -->
                </select>
              </div>
              <div class="Flex_Cell" style="width: 30%">
                <select
                  v-if="c.rating < 3 && c.rating != -1"
                  :disabled="isSubmiitted == 1"
                  id="ddlRemark"
                  v-model.trim="c.remark"
                >
                  <!--      firstItem="c.remark == '' ? 'Select': e.remark"      -->
                  <!-- <option v-if="c.remark==''" text="Select" value="select" selected="selected"></option> -->
                  <option
                    v-for="m in lst_SHTFeedbackCommentsForLowRating"
                    :key="m.CommentForLowRatingID"
                    v-bind:value="m.commentForLowRatingText"
                  >
                    {{ m.commentForLowRatingText }}
                  </option>
                </select>

                <textarea
                  v-if="c.rating > 2 || c.rating == -1"
                  :disabled="isSubmiitted == 1"
                  type="textarea"
                  style="height: 25px; width: 100%; font-size: 12pt"
                  v-model.trim="c.remark"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="Flex_Table tblEntryForm">
            <div class="Flex_Row" v-if="fBKTypeID != -1">
              <div class="Flex_Cell_Left">
                <input
                  v-if="isSubmiitted == 0 && lst_Question.length > 0"
                  type="button"
                  id="btnSaveFeedBack"
                  value="Submit Feedback"
                  style="padding: 5px 15px 5px 15px"
                  @click="showMessageBox4()"
                />
                <input
                  v-if="isSubmiitted == 0 && lst_Question.length > 0"
                  type="button"
                  id="btnRefreshFeedBack"
                  value="Refresh"
                  style="padding: 5px 15px 5px 15px"
                  @click="RefreshFeedBack()"
                />
                <input
                  type="button"
                  id="btnGoBack"
                  value="Go Back"
                  style="padding: 5px 15px 5px 15px"
                  @click="GoBack()"
                />
                <input
                  v-if="0 == 0"
                  type="button"
                  id="btnNext"
                  value="Next"
                  style="padding: 5px 15px 5px 15px"
                  @click="findNextfbkTypeID()"
                />
              </div>
            </div>
          </div>
        </fieldset>
        <ModalPopup
          style="z-index: 20000; margin-top: 80px"
          title="Model for Change Go Number"
          @closed="modalPopupClosed"
          @opened="modalPopupShown"
          v-model="showGoNumberModalPopup"
          :okButton="$refs.btnOk"
          :cancelButton="$refs.btnOk"
        >
          <div slot="title">
            <div class="Flex_Table" style="font-size: medium">
              <div class="Flex_Row" style="border-bottom: solid 1px">
                <div class="Flex_Cell">Instructions</div>
              </div>
            </div>
          </div>
          <div class="Flex_Table" style="width: 100%">
            <div class="Flex_Row">
              <div class="Flex_Cell">
                1) Please fill in the form freely and honestly.
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell">
                2) Understand meaning of every question.
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell">
                3) Try to sum up your views for the total semester before you
                select the option.
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell">
                4) Your correct feedback may contribute in improvement of our
                institute.
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell">
                5) Questionwise performance on a scale of 0 to 5 (0-worst and
                5-best).
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell">
                6) All Questions are compulsory. Please click on every rating
                bar.
              </div>
            </div>
          </div>
        </ModalPopup>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import shortCourseFeedBackJS from "./serviceJS/ShortCourseFeedBackJS.js";
import ModalPopup from "./ekkControls/ModalPopup";
import HomeJS from "./serviceJS/homeJS.js";
import NomDetailsJS from "./serviceJS/NomineeDetails.js";

export default {
  name: "ShortCourseFeedBackChanged",
  components: {
    ModalPopup: ModalPopup
  },
  props: {
    //UserTypeID: { required: true },
    // NomAuthID: { required: true, default: -1 },
  },
  data() {
    return {
      lst_FeedbackType: [],
      lst_Question: [],
      lst_Answer: [],
      lst_QuestionAnswerMap: [],
      sectionID: -1,
      fBKTypeID: -1,
      sectionID: -1,
      condidateID: -1,
      subjectLinkID: -1,
      facultyID: -1,
      color: 100,
      showGoNumberModalPopup: true,
      isSubmiitted: 0,
      progID: -1,
      index: 0,
      isSuccessStatus: false
    };
  },
  methods: {
    showHideQuestion(ele) {
      let lstShowHide = [];
      if (ele.questionID == "46") {
        //let lstShowHide = this.lst_Question.filter((r)=>  { r.questionID == "48" &&  r.questionID == "69" &&  r.questionID == "70 });
        //console.log(ele);
        lstShowHide = this.lst_Question.filter(r => {
          return (
            r.questionID == "48" || r.questionID == "69" || r.questionID == "70"
          );
        });
      }
      if (ele.questionID == "36") {
        //let lstShowHide = this.lst_Question.filter((r)=>  { r.questionID == "48" &&  r.questionID == "69" &&  r.questionID == "70 });
        //console.log(ele);
        lstShowHide = this.lst_Question.filter(r => {
          return (
            r.questionID == "47" || r.questionID == "68" || r.questionID == "71"
          );
        });
      }
      if (ele.answeresEntered == "80") {
        lstShowHide.forEach(f => {
          f.isVisible = 0;
          f.answeresEntered = "";
        });
      } else {
        lstShowHide.forEach(f => {
          f.isVisible = 1;
        });
      }
    },
    getFeedbackType() {
      let _data = { LoginID: -1, ProgID: this.progID };
      shortCourseFeedBackJS.getFeedbackType(_data).then(response => {
        if (response.data) {
          this.lst_FeedbackType = response.data;
          this.condidateID = this.lst_FeedbackType[0].candidateID;
        }
      });
    },
    getQuestion() {
      let _data = {
        QuestionID: -1,
        AnsID: -1,
        FBKTypeID: this.fBKTypeID,
        SectionID: this.sectionID,
        CandidateID: this.condidateID,
        SubjectLinkID: this.subjectLinkID,
        FacultyID: this.facultyID
      };
      shortCourseFeedBackJS.getQuestion(_data).then(response => {
        this.lst_Question = [];
        if (response.data) {
          response.data.forEach(i => {
            let answerLst = [];
            let candidateAnswer = "";

            this.lst_Answer.forEach(a => {
              if (a.questionID == "46") {
                //console.log(a);
              }
              if (i.questionID == a.questionID && i.qTypeID == 1) {
                answerLst.push({
                  questionID: a.questionID,
                  answerID: a.answerID,
                  answer: a.answer,
                  sortorder: a.sortorder,
                  candAnswer: a.candAnswer
                });
              }
              if (i.questionID == a.questionID && a.candAnswer != "") {
                candidateAnswer = a.candAnswer;
              }
            });
            //var answerLstString = JSON.stringify(answerLst);
            //var answerLst1 = JSON.parse(answerLstString);
            this.lst_Question.push({
              sNo: i.sNo,
              fbkTypeID: i.fbkTypeID,
              fbkType: i.fbkType,
              questionID: i.questionID,
              question: i.question,
              qTypeID: i.qTypeID,
              qType: i.qType,
              isDeactive: i.isDeactive,
              sectionID: i.sectionID,
              section: i.section,
              conceptID: i.conceptID,
              answerLst: answerLst,
              answeresEntered:
                (i.questionID == "46" || i.questionID == "36") &&
                candidateAnswer == ""
                  ? "80"
                  : candidateAnswer,
              candidateID: this.condidateID,
              isVisible: i.isVisible
            });
          });
        }
      });
    },
    getfeedbackdata(type) {
      var str = "";
      if (this.lst_Question.length > 0) {
        this.lst_Question.forEach((element, idx) => {
          if (element.rating == -1) {
            str = "Rating must be greater than or equal to 0 !!";
          }
        });
        if (str != "") {
          MessageBox.show({
            message: str,
            type: "error",
            title: "Error"
          });
          return false;
        }
        MessageBox.show(
          {
            message:
              "After Saving You Can't Edit Data . <br/> Click Yes to Save ",
            type: "confirm",
            title: "",
            defaultButton: 3
          },
          {
            buttonName: "Yes",
            buttonAction: this.saveWarningFeedBack
          },
          { buttonName: "Cancel", buttonAction: this.showFlashMessage }
        );
      }
    },
    findNextfbkTypeID() {
      // this.SaveFeedBack();
      this.isSuccessStatus = false;
      //if (this.isSubmiitted == 0) {
        this.showMessageBox4();

        this.$nextTick(() => {
          if (this.isSuccessStatus || this.isSubmiitted == 1) {
            var index = this.index;
            for (var i = index + 1; i < this.lst_FeedbackType.length; i++) {
              //if (this.lst_FeedbackType[i].isFbkGiven == 0) {
                this.nextfbkTypeID = this.lst_FeedbackType[i].fbkTypeID;

                this.fBKTypeID = this.nextfbkTypeID;
                this.isSubmiitted = this.lst_FeedbackType[i].isFbkGiven;
                this.getAnswer(i, this.lst_FeedbackType[i].isFbkGiven);
                return;
              //}
            }
            for (var i = 0; i < index; i++) {
              //if (this.lst_FeedbackType[i].isFbkGiven == 0) {
                this.nextfbkTypeID = this.lst_FeedbackType[i].fbkTypeID;

                this.fBKTypeID = this.nextfbkTypeID;
                this.isSubmiitted = this.lst_FeedbackType[i].isFbkGiven;
                this.getAnswer(i, this.lst_FeedbackType[i].isFbkGiven);
                return;
             // }
            }
          }
        });
      //}
      // if (this.isSubmiitted == 1) {
      //   var index = this.index;
      //       for (var i = index + 1; i < this.lst_FeedbackType.length; i++) {
      //         if (this.lst_FeedbackType[i].isFbkGiven == 1) {
      //           this.nextfbkTypeID = this.lst_FeedbackType[i].fbkTypeID;

      //           this.fBKTypeID = this.nextfbkTypeID;
      //           this.isSubmiitted = this.lst_FeedbackType[i].isFbkGiven;
      //           this.getAnswer(i, this.lst_FeedbackType[i].isFbkGiven);
      //           return;
      //         }
      //       }
      //       for (var i = 0; i < index; i++) {
      //         if (this.lst_FeedbackType[i].isFbkGiven == 1) {
      //           this.nextfbkTypeID = this.lst_FeedbackType[i].fbkTypeID;

      //           this.fBKTypeID = this.nextfbkTypeID;
      //           this.isSubmiitted = this.lst_FeedbackType[i].isFbkGiven;
      //           this.getAnswer(i, this.lst_FeedbackType[i].isFbkGiven);
      //           return;
      //         }
      //       }
      //   // this.getAnswer(index, c.isFbkGiven);
      // }
    },
    getAnswer(index, ele) {
      this.condidateID = this.lst_FeedbackType[0].candidateID;
      this.isSubmiitted = ele;
      this.index = index;
      if (this.fBKTypeID != 12) {
        let _data1 = {
          QuestionID: -999,
          AnsID: -1,
          FBKTypeID: this.fBKTypeID,
          SectionID: this.sectionID,
          CandidateID: this.condidateID,
          SubjectLinkID: this.subjectLinkID,
          FacultyID: this.facultyID
        };
        shortCourseFeedBackJS.getAnswer(_data1).then(response => {
          if (response.data) {
            this.getQuestion();
            this.lst_Answer = response.data;
          }
        });
      }
      if (this.fBKTypeID == 12) {
        this.lst_Question = [];
        let _data2 = {
          CandidateID: this.condidateID,
          CourseID: this.progID,
          FBKTypeID: this.fBKTypeID
        };
        shortCourseFeedBackJS
          .GetCandidateFacultySubject(_data2)
          .then(response => {
            if (response.data) {
              this.lst_Question = response.data;
            }
          });
      }
    },
    getQuestionAnswerMap() {
      let _data = {
        QuestionID: -1,
        AnsID: -1,
        FBKTypeID: this.fBKTypeID,
        SectionID: this.sectionID,
        CandidateID: this.condidateID,
        SubjectLinkID: this.subjectLinkID,
        FacultyID: this.facultyID
      };
      shortCourseFeedBackJS.getQuestionAnswerMap(_data).then(response => {
        if (response.data) {
          this.lst_Answer = response.data;
        }
      });
    },
    showMessageBox4(e) {
      let isSubmit = 0;
      this.lst_FeedbackType.forEach(element => {
        if (element.fbkTypeID == this.fBKTypeID) {
          //fbkDateID = "4985543277323498820";
          isSubmit = element.isFbkGiven;
        }
      });
      if (isSubmit == 1) {
        MessageBox.show({
          message: "FeedBack Already Submitted",
          type: "alert",
          title: "Application says"
        });
        this.isSuccessStatus = true;
        return;
      }
      var str = "";
      //alert(this.lst_Question.length);
      if (this.lst_Question.length > 0) {
        this.lst_Question.forEach((element, idx) => {
          if (element.rating == -1) {
            str = "Rating must be greater than or equal to 0 !!";
          }
        });
        if (str != "") {
          MessageBox.show({
            message: str,
            type: "error",
            title: "Error"
          });
          // this.isSuccessStatus=false;
          return;
        }
        MessageBox.show(
          {
            message:
              "After Saving You Can't Edit Data . <br/> Click Yes to Save ",
            type: "confirm",
            title: "",
            defaultButton: 3
          },
          {
            buttonName: "Yes",
            buttonAction: this.saveWarningFeedBack
          },
          { buttonName: "Cancel", buttonAction: this.showFlashMessage }
        );
      }
    },
    saveWarningFeedBack() {
      MessageBox.show(
        {
          message:
            "Are you Sure for Saving ? <br/>  After Saving You Can't Edit Data ? <br/> Click Yes to Save ",
          type: "confirm",
          title: "",
          defaultButton: 3
        },
        {
          buttonName: "Yes",
          buttonAction: this.SaveFeedBack
        },
        { buttonName: "Cancel", buttonAction: this.showFlashMessage }
      );
    },
    SaveFeedBack() {
      let fbkDateID = "";
      let isSubmit = 0;
      this.lst_FeedbackType.forEach(element => {
        if (element.fbkTypeID == this.fBKTypeID) {
          fbkDateID = element.fbkDateID;
          isSubmit = element.isFbkGiven;
        }
      });
      if (isSubmit == 1) {
        MessageBox.show({
          message: "FeedBack Already Submitted",
          type: "alert",
          title: "Application says"
        });
        this.isSuccessStatus = true;
        return;
      }
      if (isSubmit == 1) {
        MessageBox.show({
          message: "FeedBack Already Submitted",
          type: "alert",
          title: "Application says"
        });
        this.isSuccessStatus = true;
        return;
      }
      if (
        this.lst_Question.filter(
          f => f.rating > 0 && f.rating < 3 && f.remark == "Select"
        ).length > 0
      ) {
        MessageBox.show({
          message: "Remark is mandatory where rating is below 3 !",
          type: "alert",
          title: "Application says"
        });
        return;
      }

      if (this.fBKTypeID == 12) {
        let lstSave = [];
        this.lst_Question.forEach(element => {
          if (element.rating != "-1") {
            lstSave.push({
              FBKDateID: fbkDateID,
              SUBLINKID: element.shortSubjectID,
              FacultyID: element.facultyID,
              Ratings: element.rating,
              FBKTypeID: element.fbkTypeID,
              IsShortCourse: element.isShortCourse,
              Remark: element.remark == "Select" ? "" : element.remark
            });
          }
        });
        let _data = {
          CandidateID: this.condidateID,
          lstShortCourseFeedBackNew: lstSave
        };
        shortCourseFeedBackJS
          .SaveShortCourseFeedbackNew(_data)
          .then(response => {
            if (response.data) {
              if (response.data[0].isSuccess == true) {
                this.getFeedbackType();
                this.findNextfbkTypeID();
                //this.getAnswer();

                MessageBox.show({
                  message: response.data[0].msg,
                  type: "success",
                  title: "Application says"
                });
                this.isSuccessStatus = true;
              } else {
                MessageBox.show({
                  message: response.data[0].msg,
                  type: "alert",
                  title: "Application says"
                });
              }
            }
          });
      } else {
        let _data = { FbkDateID: fbkDateID, lstFeedBack: this.lst_Question };
        shortCourseFeedBackJS.SaveFeedBack(_data).then(response => {
          if (response.data) {
            if (response.data[0].isSuccess == true) {
              this.getFeedbackType();
              this.findNextfbkTypeID();

              //this.getAnswer();

              MessageBox.show({
                message: response.data[0].msg,
                type: "success",
                title: "Application says"
              });
              this.isSuccessStatus = true;
            } else {
              MessageBox.show({
                message: response.data[0].msg,
                type: "alert",
                title: "Application says"
              });
            }
          }
        });
      }
    },
    RefreshFeedBack() {
      this.getAnswer(0, 0);
      this.getFeedbackType();
    },
    modalPopupClosed(e) {},
    modalPopupShown(e) {},
    OpenModelInstruction() {
      this.showGoNumberModalPopup = true;
    },
    GoBack() {
      this.$router.push({ name: "Home" });
    },

    GetSHTFeedbackCommentsForLowRating() {
      let _data = {};
      shortCourseFeedBackJS
        .GetSHTFeedbackCommentsForLowRating(_data)
        .then(response => {
          if (response.data) {
            this.lst_SHTFeedbackCommentsForLowRating = response.data;
            //this.condidateID = this.lst_FeedbackType[0].candidateID;
          }
        });
    }
  },
  mounted() {
    this.progID = this.$root.$data.ProgID;
    // console.log(this.progID);
    if (this.progID == undefined || this.progID == null) {
      this.$router.push({ name: "Home" });
    }
    this.getFeedbackType();
    this.GetSHTFeedbackCommentsForLowRating();
  }
};
</script>
<style scoped>
.ansClass {
  padding: 5px 3px 3px 4px;
  background-color: rgb(186 225 249);
  border-radius: 6px;
  font-size: 12pt;
  margin: 2px;
}
.ansClass[classValue="31"] {
  background-color: rgb(198, 245, 127) !important;
}
.ansClass[classValue="32"] {
  background-color: lightgreen !important;
}
.ansClass[classValue="33"] {
  background-color: grey !important;
}
.ansClass[classValue="94"] {
  background-color: orange !important;
}
.ansClass[classValue="29"] {
  background-color: lightcoral !important;
}
.ansClass[classValue="79"] {
  background-color: lightgreen !important;
}
.ansClass[classValue="80"] {
  background-color: lightcoral !important;
}
.ansClass[classValue="28"] {
  background-color: rgb(255, 67, 67) !important;
}
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}
.tblEntryForm > .Flex_Cell {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ShortCourseFeedBackChanged.vue